import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Box} from 'views/components';

import JobSettingsData from './JobSettingsData';
import JobSettingsDrawer from './JobSettingsDrawer';


const JobSettings = (props) => {
  const {showSettings, openDrawerView, setOpenDrawerView} = props;

  return (
    <>
      {
        !showSettings &&
        <Box sx={{width: '23vw', maxWidth: '296px', position: 'sticky', top: 16}}>
          <JobSettingsData
            {...props}
          />
        </Box>
      }
      {
        openDrawerView &&
        <JobSettingsDrawer
          settingsDrawerOpen={openDrawerView}
          setSettingsDrawerOpen={setOpenDrawerView}
        >

          <JobSettingsData
            {...props}
          />
        </JobSettingsDrawer>
      }
    </>
  );
};

JobSettings.propTypes = {
  showSettings: PropTypes.bool.isRequired,
  openDrawerView: PropTypes.bool.isRequired,
  setOpenDrawerView: PropTypes.func.isRequired,
  jobData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(JobSettings));
